import styled from '@emotion/styled'
import * as React from 'react'

import { palette } from 'main/ui'
import Heart from './Heart'

export enum Style {
  Bright = 'bright',
  Dark = 'dark',
}

interface IProps {
  isBookmarked: boolean
  style: Style
  onClick: () => void
}

const styles = {
  [Style.Bright]: {
    bookmarked: {
      fill: palette.rose,
      fillOpacity: 1,
      stroke: palette.rose,
    },
    unbookmarked: {
      fill: palette.chrome,
      fillOpacity: 0,
      stroke: palette.chrome,
    },
  },
  [Style.Dark]: {
    bookmarked: {
      fill: palette.rose,
      fillOpacity: 1,
      stroke: palette.rose,
    },
    unbookmarked: {
      fill: palette.black,
      fillOpacity: 0.1,
      stroke: palette.white,
    },
  },
}

const Container = styled.div`
  cursor: pointer;
  width: 20px;
`

export default function Icon(props: IProps) {
  const { isBookmarked, style, onClick } = props
  const { fill, fillOpacity, stroke } = isBookmarked
    ? styles[style].bookmarked
    : styles[style].unbookmarked

  return (
    <Container onClick={onClick}>
      <Heart fill={fill} fillOpacity={fillOpacity} stroke={stroke} />
    </Container>
  )
}
